import React from "react";
import {Route, Router, Switch} from "react-router-dom";
import Thread from "./Thread";
import Create from "./Create";
import All from "./All";
import Online from "./Online";

const Routes = props => {
  return (
    <Router {...props}>
      <Switch>
        <Route
          path="/panel/pitches/online"
          render={props => (
            <Online threadUrl={pitchId => `/panel/pitches/${pitchId}/thread`} />
          )}
        />
        <Route
          path="/panel/pitches/create"
          render={() => (
            <Create
              makeCreatedPitchPath={pitchId => `/panel/pitches/${pitchId}/thread`}
            />
          )}
        />
        <Route
          path="/panel/pitches/:pitchId/thread"
          render={props => (
            <Thread
              pitchId={props.match.params.pitchId}
            />
          )}
        />
        <Route
          render={() => (
            <All
              onlineVideosUrl="/panel/pitches/online"
              threadUrl={pitchId => `/panel/pitches/${pitchId}/thread`}
              createUrl="/panel/pitches/create"
            />
          )}
        />
      </Switch>
    </Router>
  );
};

export default Routes;
